export const SET_LINK_ORGA = "SET_LINK_ORGA";
export const CLOSE_LINK_ORGA = "CLOSE_LINK_ORGA";
